export default __webpack_public_path__ + "static/team6-e943a19b832ca271a11988e34fda1d05.jpg";